module.exports = __webpack_public_path__ + "images/home-dingtalk-work/phone-8a5593daa513efc8ecadbbb695bcfcc5.png";